module.exports = __webpack_public_path__ + "static/media/icon_charts.fd88931e.svg";